import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormContext } from "../context/Context";
import axiosInstance from "../../utils/Axios";
import CircularProgress from "@mui/material/CircularProgress";

const Payment = () => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    selectedSchoolPrefix,
    setSelectedPaymentTypeLetter,
    selectedPaymentOption,
    setSelectedPaymentOption,
    selectedStudentData,
    paymentData,
    setPaymentData,
  } = useFormContext();

  useEffect(() => {
    const getPaymentData = async () => {
      setIsLoading(true);
      try {
        const formData = new FormData();
        formData.append(
          "school_prefix",
          selectedSchoolPrefix || selectedStudentData?.school_prefix
        );

        const response = await axiosInstance.post(
          "/get_school_menu_list/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setPaymentData(response?.data?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getPaymentData();
  }, [
    selectedSchoolPrefix,
    selectedStudentData?.school_prefix,
    setPaymentData,
  ]);

  const handleChange = (event) => {
    const selectedPaymentLetter = event.target.value;
    setSelectedPaymentOption(selectedPaymentLetter);
    setSelectedPaymentTypeLetter(selectedPaymentLetter);
  };

  return (
    <div className="payment_container">
      {isLoading ? (
        <main style={{ width: "100%", alignItems: "center" }}>
          <CircularProgress />
        </main>
      ) : (
        <FormControl component="fieldset" fullWidth>
          <FormLabel
            component="legend"
            sx={{
              textAlign: "left",
              marginBottom: "10px",
              fontWeight: 600,
              color: "#333",
            }}
          >
            Select Payment Type
          </FormLabel>
          <RadioGroup
            aria-labelledby="payment-options-radio-group"
            name="payment-options-radio-group"
            value={selectedPaymentOption}
            onChange={handleChange}
          >
            {Array.isArray(paymentData) &&
              paymentData.map((pData, index) => (
                <FormControlLabel
                  key={index}
                  value={pData?.transaction_type_letter}
                  control={<Radio sx={{ color: "#635bff", "&.Mui-checked": { color: "#635bff" } }} />}
                  label={pData?.transaction_type_title.toUpperCase()}
                  sx={{
                    marginBottom: "4px",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                    marginLeft: 0,
                    marginRight: 0,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: "#f5f5ff",
                      borderColor: "#635bff",
                    },
                  }}
                />
              ))}
          </RadioGroup>
        </FormControl>
      )}
    </div>
  );
};

export default Payment;

